<div *ngIf="user" (mouseenter)="hovered=true" (mouseleave)="hovered=false" class="group p-3 border-t border-slate-900">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row items-center gap-3">
      <app-avatar class="shrink-0" [user]="user" size="sm"></app-avatar>
      <div>
        <span class="text-lg">{{user.givenName}} {{user.familyName}}</span>
        <div *ngIf="groupmateSummary" class="text-sm">
          <span *ngIf="groupmateSummary.count == 1" >
            <span class="text-muted">You worked together</span>
            {{groupmateSummary.lastGroupedAt | timeago}}<span class="text-muted">.</span>
          </span>
          <p *ngIf="groupmateSummary && groupmateSummary.count > 1">
            <span class="text-muted">You have worked together</span>
            {{groupmateSummary.count}}
            <span class="text-muted">times, most recently</span>
            {{groupmateSummary.lastGroupedAt | timeago}}<span class="text-muted">.</span>
          </p>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="hovered && (user.bio || groupmateSummary)" [@fadeInOut] class="pt-3 overflow-hidden">
    <p *ngIf="user.bio" class="text-sm mb-3">"{{user.bio}}"</p>
  </div>
</div>
